import { render, staticRenderFns } from "./private.vue?vue&type=template&id=2ea3d0aa&scoped=true&"
import script from "./private.vue?vue&type=script&lang=js&"
export * from "./private.vue?vue&type=script&lang=js&"
import style0 from "./private.vue?vue&type=style&index=0&id=2ea3d0aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea3d0aa",
  null
  
)

export default component.exports